<div id="imageoneFranchise" *ngIf="imageoneFranchise">
    <imageone-franchise [pageDisplay]="pageDisplay" [pageTitle]="pageTitle">
    </imageone-franchise>
</div>